import { Box } from '@mui/material';
import AccordionSection from './learn-more-components/AccordionSection';
import CopySection from './learn-more-components/CopySection';
import {
  AccordionContentDto,
  CopyContentDto,
  LearnMoreContentDto,
} from '@act/shared/data-transfer-objects';

const LearnMoreDialogContent = ({
  learnMoreContent,
}: {
  learnMoreContent: LearnMoreContentDto;
}) => {
  return (
    <>
      {[...learnMoreContent.sections]
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map(section => {
          const { sortOrder, type } = section;
          return (
            <Box
              component="div"
              key={`section-${type}-${sortOrder}`}
              className="learn-more-section"
              sx={{
                '&:not(:last-child)': {
                  width: '100%',
                  marginBottom: '24px',
                },
              }}
            >
              <Box
                component="div"
                sx={{ width: '100%', boxSizing: 'border-box' }}
              >
                {type === 'accordion' && (
                  <AccordionSection content={section as AccordionContentDto} />
                )}
                {type === 'copy' && (
                  <CopySection content={section as CopyContentDto} />
                )}
              </Box>
            </Box>
          );
        })}
    </>
  );
};

export default LearnMoreDialogContent;
